// Simple visibility check function
function isElementVisible(element) {
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  return rect.top < windowHeight && rect.bottom > 0;
}

(function ($) {
	// counter
	$.fn.countto = function (options) {
		// merge the default plugin settings with the custom options
		options = $.extend({}, $.fn.countto.defaults, options || {});

		// how many times to update the value, and how much to increment the value on each update
		let loops = Math.ceil(options.speed / options.refreshinterval),
			increment = (options.to - options.from) / loops;

		return $(this).each(function () {
			let _this = this,
				loopCount = 0,
				value = options.from,
				interval = setInterval(updateTimer, options.refreshinterval);

			function updateTimer() {
				value += increment;
				loopCount++;
				$(_this).html(value.toFixed(options.decimals));

				if (typeof (options.onupdate) == 'function') {
					options.onupdate.call(_this, value);
				}

				if (loopCount >= loops) {
					clearInterval(interval);
					value = options.to;

					if (typeof (options.oncomplete) == 'function') {
						options.oncomplete.call(_this, value);
					}
				}
			}
		});
	};

	// set default counter param
	$.fn.countto.defaults = {
		from: 0,  // the number the element should start at
		to: 100,  // the number the element should end at
		speed: 1000,  // how long it should take to count between the target numbers
		refreshinterval: 100,  // how often the element should be updated
		decimals: 0,  // the number of decimal places to show
		onupdate: null,  // callback method for every time the element is updated,
		oncomplete: null,  // callback method for when the element finishes updating
	};

	let footerMenu = null,
		mobileArrow = null,
		ratingConclusion = null,
		tlDrItem = null,
		tlDrCarouselDotsIndicator = null,
		faqItem = null,
		isAnimate = null,
		isVisible = null,
		ratingSlot = null,

		casino = {
			ratingAnimation: function () {
				setTimeout(function () {
					// rating lines animation
					$('.rating-fill').each(function () {
						if ($(this).data('width')) {
							$(this).css('width', 'calc( ' + $(this).data('width') + '% + 2px )');
						}
					});
					// total rating animation (counter)
					$('.total-rating span:first-child').countto({
						to: $('.total-rating span:first-child').data('rating'),
						speed: 1500,
						refreshinterval: 10,
					});
					// rating items animation
					$('.label-wrapper span.value').each(function () {
						if ($(this).data('rating')) {
							$(this).countto({
								to: $(this).data('rating'),
								speed: 1500,
								refreshinterval: 10,
							});
						}
					});
				}, 500);
				isAnimate = true;
			},
			slotRaingInit(rating) {
				if ( rating ) {
					rating.each(function() {
						let ratingWidth = $(this).find('.rating-fill');
						$(this).find('.rating-fill').css('width', 'calc( ' + ratingWidth.data('width') + '% + 2px )');
					});
				}
			},
			checkScroll: function (isVisible) {
				if (!isAnimate && isVisible) {
					this.ratingAnimation();
				}
			},
			initCarousel: function (item, carouselIndicator) {
				if (item && carouselIndicator) {
					item.addClass('active');
					carouselIndicator.addClass('active');
					carouselIndicator.attr('aria-current', 'true');
				}
			},
			normalizeSlideHeights: function () {
				$('.carousel').each(function () {
					let items = $('.carousel-item');
					items.css('min-height', 0);
					let maxHeight = Math.max.apply(null,
						items.map(function () {
							return $(this).outerHeight()
						}).get());
					items.css('min-height', maxHeight + 'px');
				})
			},
			faqCollapse: function (item) {
				item.on('click', function (event) {
					event.preventDefault();
					let answer = $(this).children('.schema-faq-answer');

					answer.slideToggle();
					answer.toggleClass('show');
					answer.parent(faqItem).toggleClass('open');
				});
			},
			variableInit: function () {
				footerMenu = $('.footer-menu');
				mobileArrow = $('.mobile-arrow');
				ratingConclusion = $('#rating-conclusion');
				tlDrItem = $('#carouselTlDr .carousel-item').first().length > 0 ? $('.tl-dr .carousel-item').first() : null;
				tlDrCarouselDotsIndicator = $('#carouselTlDr .indicators-wrapper button').first().length > 0 ? $('#carouselTlDr .indicators-wrapper button').first() : null;
				faqItem = $('.schema-faq-section');
				ratingSlot = $('.slot-rating-wrapper').length > 0 ? $('.slot-rating-wrapper') : null;
				isAnimate = false;
				isVisible = isElementVisible(ratingConclusion[0]);
			},
			init: function () {
				this.variableInit();
				this.checkScroll(isVisible);
				this.initCarousel(tlDrItem, tlDrCarouselDotsIndicator);
				this.faqCollapse(faqItem);
				this.slotRaingInit(ratingSlot);
			},
		};
	casino.init();

	// preventDefault footer menu title
	footerMenu.children('li').children('a').on('click', function (event) {
		event.preventDefault();
	})

	// mobile menu show second level on click
	mobileArrow.on('click', (function (event) {
		event.preventDefault();
		$(this).toggleClass('rotate');
		$(this).parents(':eq(1)').toggleClass('dropdown-show');
		$(this).parents(':eq(1)').children('.dropdown-menu').slideToggle();
	}));

	$(window).on('load', function () {
		casino.normalizeSlideHeights();
	});

	$(window).on('resize', function () {
		casino.normalizeSlideHeights();
	});

	$(window).on('scroll', function () {
		casino.checkScroll(isElementVisible(ratingConclusion[0]));
	});
}(jQuery));